import { gateway } from "../../../../gateway";
import type { IRefundInvoicePayload, IRefundInvoiceResponse } from "../../create/interfaces/invoice.interfaces";

export const refundInvoiceAction = async (
  invoiceUid: string,
  companyId: number,
  payload?: IRefundInvoicePayload
): Promise<IRefundInvoiceResponse["data"]> => {
  const response = await gateway.post<IRefundInvoiceResponse>(
    `/invoices/${invoiceUid}/refund`,
    payload ?? {},
    {
      headers: {
        "x-company-id": companyId.toString(),
      },
    }
  );
  return response.data?.data;
};
